/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { Routes } from 'utils/routes';
import { useRouter } from 'next/router';

const ArticlesPreviews = ({
    firstArticleId = 'uvildig-raadgivning-en-god-beslutning',
    secondArticleId = 'en-nedsparingsraadgivning-gav-birthe-300000-kr-mere-til-pension',
    style,
    classNames ='',
    onlySections = false,
}) => {
    const router = useRouter();

    const articlePreviews = {
        'skab-en-god-overgang-til-pension':
        (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-14.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('skab-en-god-overgang-til-pension')) }
                ></div>
                <div>
                    <h3>Skab en god overgang fra fuldtidsarbejde til folkepension</h3>
                    <p>
                        Deltid, delpension, efterløn eller fuld fart frem til folkepensionen? Kender du dine muligheder?
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('skab-en-god-overgang-til-pension')) }>Læs mere</a>
                </div>
            </section>
        ),
        'kan-jeg-straekke-min-ratepension': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-17.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('kan-jeg-straekke-min-ratepension')) }
                ></div>
                <div>
                    <h3>Stræk din ratepension mellem 10 og 30 år og få mere til dig selv</h3>
                    <p>
                        Få svar på, hvorfor det giver god mening at strække din ratepension, og hvad det kan betyde økonomisk at gøre det.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('kan-jeg-straekke-min-ratepension')) }>Læs mere</a>
                </div>
            </section>
        ),
        'opnaa-oekonomisk-tryghed-med-en-nedsparingsraadgivning': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-11-nedsparing.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('opnaa-oekonomisk-tryghed-med-en-nedsparingsraadgivning')) }
                ></div>
                <div>
                    <h3>Opnå økonomisk tryghed med en nedsparings-rådgivning og få flere penge til dig selv</h3>
                    <p>
                        Du har sparet op til pension, siden den dag du satte din fod på arbejdsmarkedet. Det ligger så indgroet i os at spare op til pension, så når vi nærmer os den tid, hvor vi skal
                        tage hul på vores opsparinger, oplever mange det som udfordrende. Ydermere er reglerne omkring pension og pensionstillæg komplicerede, hvilket resulterer i, at mange går glip
                        af penge. Simpelthen fordi de bruger pengene i en uhensigtsmæssig rækkefølge.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('opnaa-oekonomisk-tryghed-med-en-nedsparingsraadgivning')) }>Læs mere</a>
                </div>
            </section>
        ),
        'i-hvilken-raekkefoelge-skal-man-bruge-sine-penge-naar-man-gaar-paa-pension': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-13.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('i-hvilken-raekkefoelge-skal-man-bruge-sine-penge-naar-man-gaar-paa-pension')) }
                ></div>
                <div>
                    <h3>I hvilken rækkefølge skal man bruge sine penge, når man går på pension?</h3>
                    <p>
                        Pensionisttilværelsen er en livsfase, som mange ser frem til. Det er tidspunktet, hvor du kan nyde frugterne af dit arbejde og bruge mere tid på de ting, du virkelig holder af. Men for at opnå økonomisk tryghed og frihed som pensionist, er det vigtigt at have en velovervejet plan for, hvordan du bruger din opsparing.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('i-hvilken-raekkefoelge-skal-man-bruge-sine-penge-naar-man-gaar-paa-pension')) }>Læs mere</a>
                </div>
            </section>
        ),
        'hvad-kan-en-uvildig-pensionsraadgiver-give-mig-svar-paa': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/penly-content-18.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('hvad-kan-en-uvildig-pensionsraadgiver-give-mig-svar-paa')) }
                ></div>
                <div>
                    <h3>Hvad kan en uvildig rådgiver give mig svar på?</h3>
                    <p>
                        Hvad er 60-årsret og hvad stiller du op med den? Har du flere pensioner og kan det muligvis betale sig at slå dem sammen? Sparer du nok op? Det er nogle af de svar du kan få,
                        når du taler med den uvildige rådgiver.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('hvad-kan-en-uvildig-pensionsraadgiver-give-mig-svar-paa')) }>Læs mere</a>
                </div>
            </section>
        ),
        'en-nedsparingsraadgivning-gav-birthe-300000-kr-mere-til-pension': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-7-birthe-monrad-1.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('en-nedsparingsraadgivning-gav-birthe-300000-kr-mere-til-pension')) }
                ></div>
                <div>
                    <h3>Nedsparings-rådgivning gav Birthe 300.000 kr. mere til pension</h3>
                    <p>
                        &quot;Det var rart at tale med en uvildig rådgiver om mine muligheder. Lige præcis det, at han var uvildig, gjorde mig tryg fordi han netop er neutral og objektiv.&quot;
                        fortæller Birthe.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('en-nedsparingsraadgivning-gav-birthe-300000-kr-mere-til-pension')) }>Læs mere</a>
                </div>
            </section>
        ),
        'uvildig-raadgivning-en-god-beslutning': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/penly-testimonial-person-torben.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('uvildig-raadgivning-en-god-beslutning')) }
                ></div>
                <div>
                    <h3>Uvildig rådgivning blev en af torbens bedste beslutninger</h3>
                    <p>
                        Livet som pensionist er noget mange danskere ser frem til, og det er med god grund: det er her vi kan nyde vores tilværelse, trække os tilbage fra arbejdet og investere noget
                        tid i os selv. Men pension betyder for de fleste også, at deres økonomi bliver markant ændret og det kan være en udfordring at vide hvordan man får mest ud af sin økonomi.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('uvildig-raadgivning-en-god-beslutning')) }>Læs mere</a>
                </div>
            </section>
        ),
        '6-gode-raad-til-hvordan-du-skaber-et-meningsfuldt-seniorliv': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/penly-content-59.webp)' }}
                    onClick={ () => router.push(Routes.Articles.Article('6-gode-raad-til-hvordan-du-skaber-et-meningsfuldt-seniorliv')) }
                ></div>
                <div>
                    <h3>6 GODE RÅD TIL HVORDAN DU SKABER ET MENINGSFULDT SENIORLIV</h3>
                    <p>
                        &quot;Konsekvenserne af ikke at have noget meningsfuldt at tage sig til er alvorlige. Det kan føre til ensomhed, depression og øget alkoholindtag for blot at nævne nogle&quot;
                        Line Visti Andersson, coach og ejer af Et Rigt Liv
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('6-gode-raad-til-hvordan-du-skaber-et-meningsfuldt-seniorliv')) }>Læs mere</a>
                </div>
            </section>
        ),
        'stine-fik-et-nyt-syn-paa-pension-efter-hun-tog-penlys-pensionstjek': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-5-content-stine-olivarius-jakobsen-1.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('stine-fik-et-nyt-syn-paa-pension-efter-hun-tog-penlys-pensionstjek')) }
                ></div>
                <div>
                    <h3>Stine fik et nyt syn på pension, efter hun tog Penlys PensionsTjek</h3>
                    <p>
                        Stine Olivarius Jakobsen fik en øjenåbner efter at have taget Penlys PensionsTjek. Pension gik fra at være noget der &quot;bare var der&quot; til at være noget som Stine havde
                        overblik over, og som hun havde taget aktivt stilling til. Små justeringer gjorde også, at Stine nu bliver bedre stillet som pensionist.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('stine-fik-et-nyt-syn-paa-pension-efter-hun-tog-penlys-pensionstjek')) }>Læs mere</a>
                </div>
            </section>
        ),
        'saadan-forbereder-du-dig-smartest-til-pensionen': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/penly-content-43.webp)' }}
                    onClick={ () => router.push(Routes.Articles.Article('saadan-forbereder-du-dig-smartest-til-pensionen')) }
                />
                <div>
                    <h3>Sådan forbereder du dig smartest til pensionen</h3>
                    <p>
                        Er du fyldt 50 år, bør du se dine pensionsopsparinger efter i sømmene.
                        Få en uvildig rådgiver til at hjælpe med at lave den rette nedsparingsplan, så du får mest muligt ud af opsparingen -
                        der kan være ca. 1.000 kr. ekstra om måneden efter skat at hente blot ved at optimere dine udbetalinger.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('saadan-forbereder-du-dig-smartest-til-pensionen')) }>Læs mere</a>
                </div>
            </section>
        ),
        'morten-fik-hjaelp-til-at-optimere-sin-pension': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-6-morten-schjoetz-pedersen-1.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('morten-fik-hjaelp-til-at-optimere-sin-pension')) }
                />
                <div>
                    <h3>Morten fik hjælp til at optimere sin pension</h3>
                    <p>
                        Når man er ung, føles pension uendeligt langt væk og mange ofrer det ikke meget opmærksomhed. I takt med at man
                        bliver ældre, bliver pension mere og mere interessant. Det var også tilfældet for Morten Schjøtz-Pedersen, som
                        benyttede sig af et digitalt pensionstjek og efterfølgende uvildig rådgivning med en pensionsrådgiver. Rigtig mange
                        kan have glæde af at få kigget deres pension efter i sømmene. Tallene viser nemlig, at vi danskere snyder os selv
                        for utrolig mange penge.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('morten-fik-hjaelp-til-at-optimere-sin-pension')) }>Læs mere</a>
                </div>
            </section>
        ),
        'tove-har-faaet-overblik-over-pensionsoekonomien-og-indre-ro': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-12-tove-nedsparing.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('tove-har-faaet-overblik-over-pensionsoekonomien-og-indre-ro')) }
                />
                <div>
                    <h3>Sådan fik Tove overblik over pensionsøkonomien med uvildig rådgivning</h3>
                    <p>
                        Nedsparingsrådgivningen har givet mig et super godt overblik og en indre ro. Læs mere om, hvad Tove fik ud af rådgivningen.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('tove-har-faaet-overblik-over-pensionsoekonomien-og-indre-ro')) }>Læs mere</a>
                </div>
            </section>
        ),
        'skab-en-god-overgang': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-14.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('skab-en-god-overgang')) }
                />
                <div>
                    <h3>Sådan skaber du en <span className="color-highlight">god overgang</span> fra fuldtidsarbejde til folkepension</h3>
                    <p>
                        Deltid, delpension, efterløn eller fuld fart frem til folkepensionen? Kender du dine muligheder? Læs mere her.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('skab-en-god-overgang')) }>Læs mere</a>
                </div>
            </section>
        ),
        '10-gode-raad-inden-du-tager-en-investeringsbeslutning': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/penly-content-12.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('10-gode-raad-inden-du-tager-en-investeringsbeslutning')) }
                />
                <div>
                    <h3>10 gode råd inden du tager en <span className="color-highlight">investerings-beslutning</span></h3>
                    <p>
                        Mange Penly brugere spørger os, om de skal foretage ændringer i deres investeringsportefølje i det nuværende marked, hvor kurserne svinger mere end forlystelserne i Tivoli. Derfor har vi her samlet 10 gode råd, som du bør overveje, inden du beslutter dig om en eventuel ændring i din nuværende portefølje.                </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('10-gode-raad-inden-du-tager-en-investeringsbeslutning')) }>Læs mere</a>
                </div>
            </section>
        ),
        'saadan-sparer-du-smartest-op-i-aarene-inden-pension': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-18.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('saadan-sparer-du-smartest-op-i-aarene-inden-pension')) }
                />
                <div>
                    <h3>7 gode råd til dig der vil spare rigtigt op før pensionen</h3>
                    <p>
                        Få de uvildige rådgiveres bedste råd til at spare optimalt op i årene inden pension - uanset om du betaler topskat eller ej. Læs mere.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('saadan-sparer-du-smartest-op-i-aarene-inden-pension')) }>Læs mere</a>
                </div>
            </section>
        ),
        'derfor-er-investering-relevant-for-pensionister': (
            <section>
                <div
                    style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-20.jpg)' }}
                    onClick={ () => router.push(Routes.Articles.Article('derfor-er-investering-relevant-for-pensionister')) }
                />
                <div>
                    <h3>Få 3 gode råd om investering som pensionist</h3>
                    <p>
                        Den rigtige måde at investere på i seniortilværelsen kan give dig en bedre økonomi. Find ud af, hvad du skal være opmærksom på her. Læs mere.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('derfor-er-investering-relevant-for-pensionister')) }>Læs mere</a>
                </div>
            </section>
        ),
    };
    if( onlySections ) {
        return (
            <>
                { articlePreviews[firstArticleId] }
            </>
        );
    }
    return (
        <article className={ `articlePreviews${classNames}` } style={ style }>
            { articlePreviews[firstArticleId] }
            { articlePreviews[secondArticleId] }
        </article>
    );
};

ArticlesPreviews.propTypes = {
    firstArticleId: PropTypes.string,
    secondArticleId: PropTypes.string,
};

export default ArticlesPreviews;
